import React from 'react';
import './PublicLayout.css';

/**
 * PublicLayout component - Simple layout wrapper for public pages (no authentication required)
 * Used for policy pages that should be accessible before login
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Child components to render in the main content area
 * @returns {JSX.Element} The rendered public layout with minimal structure
 */
const PublicLayout = ({ children }) => {
  return (
    <div className="public-layout">
      <header className="fire-defense-header">
        <div className="fire-defense-header-logo">
          <h2>AI Fire Defense</h2>
        </div>
      </header>
      <main className="public-content">
        {children}
      </main>
      <footer className="fire-defense-footer"></footer>
    </div>
  );
};

export default PublicLayout;
